<template>
  <div class="modal">
    <div class="modal-content">
      <p>{{ this.modalMessage }}</p>
      <div class="buttons">
        <button class="cancel-btn" @click="closeModal">Cancel The Order</button>
        <button class="wait-btn" @click="waitForSaviour">Wait...</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderSummaryModal",
  props: ["modalMessage"],
  methods: {
    waitForSaviour() {
      this.$emit("wait-for-saviour");
    },
    closeModal() {
      this.$emit("cancel-order");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 101;
  //position: absolute;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);

  .modal-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 8px;
    width: 300px;
    padding: 40px 30px;
    background-color: #fff;

    p {
      text-align: center;
    }

    button {
      align-self: center;
    }

    .buttons {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .cancel-btn {
        //flex-basis: 50%;
        align-self: center;
        background-color: rgb(255, 0, 60);
        border: 2px red solid;
        cursor: pointer;
      }

      .wait-btn {
        //flex-basis: 50%;
        //width: 50px;
        cursor: pointer;
      }
    }
  }
}
</style>
